<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.3">
      <rect x="3" y="3" width="18" height="18" rx="9" stroke="#252525" stroke-width="6" />
    </g>
  </svg>
</template>
